import { useCollapseObjects } from "hooks/collapseObjects.hook"
import { CategoriesColumns } from "./CategoriesColumns"
import { Collapse } from "components/ui/collapse/Collapse"
import { isAxiosError } from "helpers/utils.helper"
import { TTopLevelCategory } from "types/drawer.type"
import { DeleteCategoryModal } from "./layout/DeleteCategoryModal/DeleteCategoryModal"
import { ObjectCategoryDrawer } from "./layout/ObjectCategoryDrawer/ObjectCategoryDrawer"
import style from "./Categories.module.scss"

const { errorMessage } = style

type Props = {
	objectCategoriesError: Error | null
	objectCategoriesData: TTopLevelCategory[]
}

export const Categories = ({ objectCategoriesData, objectCategoriesError }: Props) => {
	const tableColumns = CategoriesColumns()

	const { generateCollapseItems } = useCollapseObjects(tableColumns)
	const collapseItems = generateCollapseItems(objectCategoriesData)

	if (objectCategoriesError) {
		if (isAxiosError(objectCategoriesError)) {
			const status = objectCategoriesError.response?.status
			if (status === 404) {
				return <div className={errorMessage}>Objects categories config not found</div>
			} else {
				return <div className={errorMessage}>Something went wrong, please try again later</div>
			}
		} else {
			return <div className={errorMessage}>An unexpected error occurred</div>
		}
	}

	return (
		<>
			<div data-testid="collapse">
				{collapseItems ? (
					<Collapse items={collapseItems} defaultActiveKey={collapseItems?.map((item) => item.key)} />
				) : null}
			</div>
			<DeleteCategoryModal />
			<ObjectCategoryDrawer />
		</>
	)
}
